import { Group, Tabs } from "@mantine/core";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import MeetingBoards from "./MeetingBoards/MeetingBoards";
import { MeetingSeries } from "./MeetingSeries/MeetingSeries";
import { setActiveMeetingAppTabInRedux } from "./meetingSlice";

export const MeetingApp: React.FC<{}> = () => {
  const meetingAppTab = useAppSelector((state) => state.meetingReducer.meetingAppTab);

  const dispatch = useAppDispatch();
  const activeTab = meetingAppTab || "MEETINGS";

  return (
    <div className="d-flex flex-column h-100 w-100 overflow-auto">
      <Group
        justify="space-between"
        align="end"
        pt="xs"
        mx="xs"
        wrap="nowrap"
        style={{ boxShadow: "inset 0 -2px 0 0 #e4e7eb" }}
      >
        <Tabs
          value={activeTab}
          onChange={(v) => {
            const next = v === "MEETING_SERIES" || v === "MEETINGS" ? v : "MEETINGS";
            dispatch(setActiveMeetingAppTabInRedux(next));
          }}
          styles={{ tab: { fontWeight: 600 } }}
        >
          <Tabs.List>
            <Tabs.Tab style={{ fontSize: "1.05em", fontWeight: 400 }} value="MEETINGS">
              Møter
            </Tabs.Tab>
            <Tabs.Tab style={{ fontSize: "1.05em", fontWeight: 400 }} value="MEETING_SERIES">
              Møteserier
            </Tabs.Tab>
          </Tabs.List>
        </Tabs>
      </Group>
      <div style={{ flex: 1, overflow: "auto" }}>
        {activeTab === "MEETINGS" && <MeetingBoards />}
        {activeTab === "MEETING_SERIES" && <MeetingSeries />}
      </div>
    </div>
  );
};
